import { focusWithoutScroll } from "@/lib/scroll";

/**
 * Clipboard helper with fallback for iframe sandboxes or older browsers.
 */
export async function copyText(text: string): Promise<boolean> {
  if (!text) return false;

  // 1. Try modern navigator.clipboard
  if (
    typeof navigator !== "undefined" &&
    navigator.clipboard &&
    typeof navigator.clipboard.writeText === "function"
  ) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Fall through to execCommand
    }
  }

  // 2. Fallback to textarea + document.execCommand
  if (typeof document !== "undefined") {
    const previousActiveElement = document.activeElement as HTMLElement | null;
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.setAttribute("readonly", "");
      ta.style.position = "fixed";
      ta.style.top = "0";
      ta.style.left = "-9999px";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      focusWithoutScroll(ta);
      ta.select();
      ta.setSelectionRange(0, text.length);
      const success = document.execCommand("copy");
      document.body.removeChild(ta);
      if (previousActiveElement) {
        focusWithoutScroll(previousActiveElement);
      }
      return success;
    } catch {
      if (previousActiveElement) {
        focusWithoutScroll(previousActiveElement);
      }
      return false;
    }
  }

  return false;
}
